import Modal from "react-responsive-modal";
import React, { useEffect } from "react";
import "react-responsive-modal/styles.css";
import { materialTableStyle, newModalStyle } from "../../reusable/styles";
import MaterialTable from "@material-table/core";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerDocumentHistory, changeCustomerDocumentStatus, downloadCustomerDocument } from "../../actions/violations";
import { useTranslation } from "react-i18next";
import { cellStyle, CustomToggle, headerStyle } from "../../columns/columnsGeneral";
import moment from "moment";
import { optionsAudit } from "../../reusable/optionsForTables";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownItem from "../../common/dropdownItem/DropdownItem";
import { customerDocumentStatus } from "../../globals";
import { Tooltip } from "@material-ui/core";
import ModalLoadingIndicator from "../../reusable/modalLoadingIndicator";


const violationsActionsCellStyle = {
  textAlign: "center",
  paddingRight: "130px",
  paddingTop: "10px",
  paddingBottom: "10px",
};

const ModalCustomerDocumentHistory = (props) => {
  const { open, close, ticketNumber } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { customerDocumentHistory } = useSelector((state) => state.violations);
  // the page-level LoadingIndicator sits below the modal overlay, so the
  // in-modal variant is used for the document download
  const { isLoading } = useSelector((state) => state.loader);

  useEffect(() => {
    dispatch(getCustomerDocumentHistory(ticketNumber));
  }, [ticketNumber, dispatch]);

  const handleChangeStatus = async (id, status) => {
    await dispatch(changeCustomerDocumentStatus(id, status));
  };

  const handleCustomerDocumentDownload = async (ticketNumber, fileName) => {
      await dispatch(
        downloadCustomerDocument(
          ticketNumber,
          fileName
        )
      );
    };

  const resendAllowed = [
    customerDocumentStatus.CANCELLED,
    customerDocumentStatus.ERROR,
    customerDocumentStatus.SENT,
    customerDocumentStatus.DELIVERED,
    customerDocumentStatus.DOWNLOADED,
    customerDocumentStatus.SUSPENDED,
  ];

  const cancelAllowed = [
    customerDocumentStatus.ERROR,
    customerDocumentStatus.CREATED,
    customerDocumentStatus.DOWNLOAD_FAILED,
    customerDocumentStatus.UNDELIVERABLE,
    customerDocumentStatus.DOWNLOADED,
  ];

  const suspendAllowed = [
    customerDocumentStatus.CREATED,
  ];

  const translateEnum = (prefix, value) =>
    t(`CustomerDocument.${prefix}.${value}`, value);

  return (
    <Modal
      open={open}
      closeOnEsc
      onClose={close}
      center
      styles={newModalStyle()}
    >
      {isLoading && <ModalLoadingIndicator />}
      <div style={{ margin: "10px" }}>
        <MaterialTable
          title={t("CustomerDocument.History")}
          style={materialTableStyle}
          data={customerDocumentHistory}
          options={optionsAudit()}
          columns={[
            {
              title: t("CustomerDocument.DocumentFileName"),
              field: "documentFilename",
              width: "20%",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
            },
            {
              title: t("CustomerDocument.DocumentType"),
              field: "documentType",
              width: "10%",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
              render: (row) => translateEnum("DocumentTypeValues", row.documentType)
            },
            {
              title: t("CustomerDocument.Status"),
              field: "status",
              width: "10%",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
              render: (row) => translateEnum("StatusValues", row.status)
            },
            {
              title: t("CustomerDocument.Holder"),
              field: "holderData",
              width: "28%",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
              render: (row) => (
                <Tooltip
                  title={<div style={{ fontSize: 14 }}>{row.holderData || ""}</div>}
                  arrow={true}
                  placement="top"
                >
                  <div
                    style={{
                      maxWidth: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.holderData || ""}
                  </div>
                </Tooltip>
              ),
            },
            {
              title: t("CustomerDocument.SendingMethod"),
              field: "sendingMethod",
              width: "12%",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
              render: (row) => translateEnum("SendingMethodValues", row.sendingMethod)
            },
            {
              title: t("CustomerDocument.CreatedOn"),
              field: "createdOn",
              width: "10%",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
              render: (row) => (
                <>{moment(row.createdOn).format("DD.MM.YYYY")}</>
              ),
            },
            {
                  title: t("Columns.Actions"),
                  width: "10%",
                  headerStyle: headerStyle,
                  filterComponent: () => null,
                  field: "actions",
                  cellStyle: violationsActionsCellStyle,
                  render: (row) => (
                    <Dropdown>
                      <Dropdown.Toggle as={CustomToggle} />
                      <Dropdown.Menu
                        size="sm"
                        style={{ color: "white", backgroundColor: "rgb(0, 90, 140)", overflowY:"scroll", maxHeight:"65vh" }}
                        popperConfig={{
                          strategy: "fixed",
                          modifiers:[
                            {
                              name: 'preventOverflow',
                              enabled: true,
                              options: {
                                altAxis: true,
                                altBoundary: true,
                                tether: true,
                                rootBoundary: 'document',
                                padding: 0,
                              },
                            },
                          ]
                        }}
                      >

                        <DropdownItem
                            disabled={false}
                            onClickAction={() => handleCustomerDocumentDownload(ticketNumber, row.documentFilename)}
                            translation={t("CustomerDocument.Menu.Download")}
                          />
                        <DropdownItem
                          disabled={!resendAllowed.includes(row.status)}
                          onClickAction={() =>
                            handleChangeStatus(
                              row.id,
                              customerDocumentStatus.CREATED
                            )
                          }
                          translation={t("CustomerDocument.Menu.Resend")}
                        />

                        <DropdownItem
                          disabled={!cancelAllowed.includes(row.status)}
                          onClickAction={() =>
                            handleChangeStatus(
                              row.id,
                              customerDocumentStatus.CANCELLED
                            )
                          }
                          translation={t("CustomerDocument.Menu.Cancel")}
                        />

                        <DropdownItem
                          disabled={!suspendAllowed.includes(row.status)}
                          onClickAction={() =>
                            handleChangeStatus(
                              row.id,
                              customerDocumentStatus.SUSPENDED
                            )
                          }
                          translation={t("CustomerDocument.Menu.Suspend")}
                        />



                      </Dropdown.Menu>
                    </Dropdown>
                  ),
                },
          ]}
        />
      </div>
    </Modal>
  );
};
export default ModalCustomerDocumentHistory;
